
<template>
<div class='game-grid-page'>
    <div class='game-grid-description' >
      <h1 v-if="activeGames.length === 0">You don't have any active games</h1>
      <h1 v-else>Continue an active game or</h1>
      <div class='game-grid-container'>
        <div class='game-grid'>
          <router-link class="btn btn-primary" to="/new-game">Start a Game</router-link>
        </div>
      </div>
    </div>
    <div class='game-grid-description' v-if="activeGames.length > 0">
      <h1>Active Games</h1>
    </div>
    <div class='game-grid-container'>
      <div class='game-grid'>
          <gamesummary v-for="(game, index) in activeGames" :game="game" :key="index"></gamesummary>
      </div>
    </div>
  <div class='game-grid-description' v-if="completedGames.length > 0">
    <h1>Completed Games</h1>
  </div>
  <div class='game-grid-container'>
    <div class='game-grid'>
        <gamesummary v-for="(game, index) in completedGames" :game="game" :key="index"></gamesummary>
    </div>
  </div>
</div>
</template>
 
<script>
import gamesummary from './GameSummary.vue'
import { mapGetters, mapActions } from 'vuex'
 
export default {
  name: "game-list",
  components: {
    gamesummary
  },
  computed: {
    ...mapGetters('games', {
      activeGames: 'activeGames',
      completedGames: 'completedGames'
    })
  },
  created() {
        this.getAllUsers();
  },
  mounted() {
    /* eslint-disable no-console */
    console.log('GameList mounted. Retrieving games')
    /* eslint-enable no-console */
  },
  methods: {
      ...mapActions('users', {
          getAllUsers: 'getAll',
          deleteUser: 'delete'
      })
  }
};
</script>
 
<style>

.game-grid-page {
  justify-content: center;
  width: 80%;
  height: 100%;
}

.game-grid-description > h1 {
  justify-content: center;
  text-align: center;
  margin: 40px 0 4px;
}

.game-grid-container {
  display: flex;
  justify-content: center;
}

.game-grid {
  width: 1400px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  padding: 5px;
}
</style>